import { Box, List, ListItem, SxProps } from '@mui/material';
import { AlertCard } from 'components/AlertCard';

const listItemSx: SxProps = {
  mt: 0.5,
  color: 'poppGrey.main',
  fontSize: '14px'
};

interface WarningAlertProps {
  title: string;
  bulletPoints: string[];
}

export const WarningListAlert: React.FC<WarningAlertProps> = ({
  title,
  bulletPoints
}) => (
  <Box sx={{ my: 2 }}>
    <AlertCard
      title={title}
      subtitle={
        <List>
          {bulletPoints.map((text, index) => (
            <ListItem key={index} disablePadding sx={listItemSx}>
              • {text}
            </ListItem>
          ))}
        </List>
      }
      type="warning"
    />
  </Box>
);
